export const useCardsGrid = () => {
    const init = () => {
        $(".ns-cards-grid").each(function () {
            const $this = $(this);
            const $container = $this.find(".ns-cards-grid__container");
            const isTwoElements = $this.hasClass("ns-cards-grid--two");
            const dragBreakpoint = isTwoElements === true ? 918 : 1140;
            const speed = 800;
            const options = {
                center: false,
                loop: false,
                autoWidth: true,
                nav: false,
                dots: false,
                margin: 16,
                smartSpeed: speed,
                responsive: {
                    0: {
                        mouseDrag: true,
                        touchDrag: true,
                    },
                    [dragBreakpoint]: {
                        mouseDrag: false,
                        touchDrag: false,
                    },
                },
            };

            $container.owlCarousel(options);
        });
    };

    const initCardsGrid = () => {
        document.addEventListener("DOMContentLoaded", init);
    };

    return {
        initCardsGrid,
    };
};
